var map = {
	"./about-us-highlight-icon.svg": 355,
	"./about-us-icon.svg": 809,
	"./about-us-mob-icon.svg": 810,
	"./accounts-highlight-admin-icon.svg": 366,
	"./accounts-highlight-icon.svg": 356,
	"./accounts-icon.svg": 811,
	"./accounts-mob-icon.svg": 812,
	"./audit-logs-highlight-admin-icon.svg": 367,
	"./audit-logs-icon.svg": 813,
	"./campaigns-highlight-admin-icon.svg": 368,
	"./campaigns-icon.svg": 814,
	"./close-icon.svg": 354,
	"./contact-us-highlight-icon.svg": 357,
	"./contact-us-icon.svg": 815,
	"./contact-us-mob-icon.svg": 816,
	"./contacts-highlight-icon.svg": 358,
	"./contacts-icon.svg": 817,
	"./contacts-mob-icon.svg": 818,
	"./coupons-highlight-admin-icon.svg": 369,
	"./coupons-icon.svg": 819,
	"./dashboard-highlight-admin-icon.svg": 370,
	"./dashboard-highlight-icon.svg": 359,
	"./dashboard-icon.svg": 820,
	"./dashboard-mob-icon.svg": 821,
	"./edit-icon.svg": 822,
	"./event-calendar-highlight-admin-icon.svg": 371,
	"./event-calendar-icon.svg": 823,
	"./invoices-highlight-icon.svg": 360,
	"./invoices-icon.svg": 824,
	"./invoices-mob-icon.svg": 825,
	"./notification-highlight-admin-icon.svg": 372,
	"./notification-highlight-icon.svg": 166,
	"./notification-icon.svg": 141,
	"./notification-mob-icon.svg": 373,
	"./orders-highlight-admin-icon.svg": 374,
	"./orders-highlight-icon.svg": 361,
	"./orders-icon.svg": 826,
	"./organisations-highlight-icon.svg": 362,
	"./organisations-icon.svg": 827,
	"./organisations-mob-icon.svg": 828,
	"./payment-gateways-highlight-admin-icon.svg": 375,
	"./payment-gateways-icon.svg": 829,
	"./plans-highlight-admin-icon.svg": 376,
	"./plans-icon.svg": 830,
	"./reminders-highlight-icon.svg": 363,
	"./reminders-icon.svg": 831,
	"./reminders-mob-icon.svg": 832,
	"./settings-highlight-admin-icon.svg": 377,
	"./settings-highlight-icon.svg": 364,
	"./settings-icon.svg": 833,
	"./settings-mob-icon.svg": 834,
	"./subscriptions-highlight-admin-icon.svg": 378,
	"./subscriptions-icon.svg": 835,
	"./templates-highlight-admin-icon.svg": 379,
	"./templates-icon.svg": 836,
	"./tick-icon.svg": 347,
	"./users-highlight-admin-icon.svg": 380,
	"./users-highlight-icon.svg": 365,
	"./users-icon.svg": 837,
	"./users-mob-icon.svg": 838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 195;